import { DEFAULT_DATE_TIME_RANGE } from '@modules/common/components/DateRangePicker/constants';
import { mapToDateTimeRange } from '@modules/common/utils';
import { TimeRangeResponse } from 'generated/graphql';

export const getDurationFromAssistantResponseEqlQuery = (
  queryDuration?: TimeRangeResponse,
) => {
  if (!queryDuration) {
    return DEFAULT_DATE_TIME_RANGE;
  }

  const duration = { ...queryDuration };

  if (duration.startAfter) {
    duration.startAfter = duration.startAfter * 1000;
  }

  if (duration.endBefore) {
    duration.endBefore = duration.endBefore * 1000;
  }

  return mapToDateTimeRange(duration);
};
